<template>
<div>
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>
    <div class="page_content_box">
        <div class="wrap">
            <div class="photo_404"><img src="../../assets/images/photo_404.jpg" alt=""></div>
            <div class="text_404">抱歉，您访问的页面不存在</div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
export default {
  // components: { TopMenu,TopBar,Footer,TopSlider },
  components: { TopMenu,Footer,TopSlider },
}
</script>

<style lang="less" scoped>
.photo_404 {
  width: 368px;
  height: 215px;
  margin: 50px auto 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.text_404 {
  line-height: 1;
  text-align: center;
  margin-top: 20px;
}
</style>
